import React from "react";
import { Link } from "react-router-dom";

type QuietButtonProps = {
  href?: string;
  to?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  "data-testid"?: string;
};

export const QuietButton: React.FC<QuietButtonProps> = ({
  href,
  to,
  onClick,
  children,
  className = "",
  ...rest
}) => {
  const classes = `inline-flex items-center gap-2 rounded-[16px] border border-cvborder bg-white px-6 py-3.5 text-[15px] font-semibold text-ink transition-colors duration-200 ease-out hover:border-ink ${className}`;

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" className={classes} onClick={onClick} {...rest}>
      {children}
    </button>
  );
};
